import script from "./Plans.vue?vue&type=script&setup=true&lang=js"
export * from "./Plans.vue?vue&type=script&setup=true&lang=js"

import "./Plans.vue?vue&type=style&index=0&id=2a2f3003&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a2f3003"]])

export default __exports__